import { render, staticRenderFns } from "./flats.vue?vue&type=template&id=3c16428e"
import script from "./flats.vue?vue&type=script&lang=js"
export * from "./flats.vue?vue&type=script&lang=js"
import style0 from "./flats.vue?vue&type=style&index=0&id=3c16428e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports